export enum BarCodeType {
    OneDimension = 0,
    TwoDimension = 1
}



// WEBPACK FOOTER //
// ./src/services/HealthCardBarcodeScanParsers/BarCodeType.ts